import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Locations', href: '/miami' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#060F1D]/97 backdrop-blur-sm border-b border-white/8 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer shrink-0">
          <div className="h-16 flex items-center">
            <img
              src="https://storage.readdy-site.link/project_files/3f4e5315-53a9-4781-b608-6e8efdbbbb26/c07fec73-4b7a-4c2e-8c3b-6c3e96222cb6_ACE-DIVING-MIAMI-PADI-SSI-SDI-TDI-ERDI-DIVE-CENTER-NEAR-ME.jpg?v=dfaed86c0c2a04c7a5c8aa26d1b83447"
              alt="Ace Diving Miami — PADI SSI SDI TDI ERDI Dive Center"
              className="h-12 w-auto object-contain"
            />
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive =
              link.href.startsWith('/#')
                ? false
                : link.href === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.href);
            return (
              <Link
                key={link.label}
                to={link.href}
                className={`text-[13px] font-semibold tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                  isActive ? 'text-[#00B4D8]' : 'text-white/65 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:+17862413194"
            className="inline-flex items-center gap-1.5 text-white/55 hover:text-[#00B4D8] text-[13px] font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm" />
            </div>
            +1 786-241-3194
          </a>
          <div className="h-4 w-px bg-white/15" />
          <Link
            to="/#contact"
            className="bg-[#00B4D8] hover:bg-[#00C9F0] text-white text-[13px] font-bold px-6 py-2.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            Start Your Journey
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white text-2xl cursor-pointer w-9 h-9 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#060F1D]/97 backdrop-blur-sm border-t border-white/10 px-6 py-7 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="text-white/70 hover:text-[#00B4D8] text-[15px] font-semibold cursor-pointer transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-4 border-t border-white/10 flex flex-col gap-3">
            <a
              href="tel:+17862413194"
              className="inline-flex items-center gap-2 text-white/55 text-sm font-semibold cursor-pointer"
            >
              <i className="ri-phone-line text-[#00B4D8] text-base" />
              +1 786-241-3194
            </a>
            <a
              href="https://wa.me/17862413194"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 text-white/55 text-sm font-semibold cursor-pointer"
            >
              <i className="ri-whatsapp-line text-[#25D366] text-base" />
              WhatsApp Us
            </a>
            <Link
              to="/#contact"
              className="bg-[#00B4D8] text-white text-sm font-bold px-6 py-3.5 rounded-full text-center cursor-pointer whitespace-nowrap mt-1"
              onClick={() => setMenuOpen(false)}
            >
              Start Your Journey
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
